export function getTokenPayload() {
  const token = localStorage.getItem("token");
  if (!token) {
    return null;
  }

  try {
    const base64Payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const binaryPayload = atob(base64Payload);
    const payload = decodeURIComponent(
      Array.from(binaryPayload)
        .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, "0")}`)
        .join("")
    );
    return JSON.parse(payload);
  } catch (error) {
    return null;
  }
}

export function getTokenExpiryTime() {
  const payload = getTokenPayload();
  return payload?.exp ? payload.exp * 1000 : null;
}

export function isTokenExpired() {
  const expiresAt = getTokenExpiryTime();
  return !expiresAt || expiresAt <= Date.now();
}

export function clearStoredAuth() {
  localStorage.removeItem("token");
}

export function getCurrentUsername() {
  return getTokenPayload()?.username || "";
}

export function roleLabel(role) {
  return {
    1: "Admin",
    2: "Site admin",
    3: "Utövare",
    4: "Föreningsadmin",
    5: "Tränare"
  }[role] || "Okänd roll";
}
